import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const styles = theme => ({
  listContainer: {
    padding: '16px 20px',
    background: '#FFF',
  },
  listIcon: {
    minWidth: 30,
  },
  allItem: {
    padding: '18px 22px !important',
    marginBottom: '0 !important',
    borderBottom: '1px solid #E9ECED',
  },
  listItemContainer: {
    cursor: 'pointer',
    padding: 0,
    marginBottom: 2,
  },
  refinementListTextContainer: {
    overflowWrap: 'break-word',
  },
  listText: theme.typography.overline,
  selectedListText: {
    ...theme.typography.caption,
    color: theme.palette.primary.main,
  },
  checkbox: {
    padding: 0,
    marginRight: 22,
  },
  icon: {
    width: 15,
    height: 15,
    marginRight: 20,
  },
});

function TypeSelector({ selectedValue, onChange, classes, data }) {
  return (
    <>
      <List disablePadding classes={{ root: classes.listContainer }}>
        {data.map(({ label, icon }) => {
          const isSelected = selectedValue === label;
          const itemIcon = isSelected ? icon[0] : icon[1];
          return renderItem(label, itemIcon, onChange, classes, isSelected);
        })}
      </List>
    </>
  );
}

function renderItem(label, itemIcon, onChange, classes, isSelected) {
  return (
    <ListItem
      key={label}
      onClick={() => onChange(label, isSelected)}
      className={classes.listItemContainer}
    >
      <ListItemIcon className={classes.listIcon}>
        <img src={itemIcon} alt="Icon" />
      </ListItemIcon>
      <ListItemText
        primary={label}
        classes={{
          root: classes.listText,
          primary: isSelected ? classes.selectedListText : classes.listText,
        }}
      />
    </ListItem>
  );
}

TypeSelector.propTypes = {
  classes: PropTypes.object,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.array,
};

export default withStyles(styles)(TypeSelector);
